export default __webpack_public_path__ + "static/placeholder-dd0ac606547369604d701afc1aa9d1e9.jpg";